/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class DataFormatterService {

  constructor(private datePipe: DatePipe) { }

  formatResults(data: any): any {
    if (data !== undefined) {
      return data.map((item: any) => {
        const formattedItem: { [key: string]: string | number | null } = {};

        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            const value = item[key];


            if (typeof value === 'string' && !isNaN(Number(value)) && !value.includes('%')) {
              let num = parseFloat(value);
              num = Math.round(num * 100) / 100;
              formattedItem[key] = num;
            }

            else if (typeof value === 'string' && value.includes('%')) {
              const percentageValue = parseFloat(value.replace('%', ''));
              const roundedPercentage = Math.round(percentageValue * 100) / 100;
              formattedItem[key] = `${roundedPercentage}%`;
            }

            else if (typeof value === 'string' && this.isValidDateFormat(value)) {
              const date = new Date(value);
              formattedItem[key] = this.datePipe.transform(date, 'EEE, dd-MM-yyyy HH:mm:ss');
            }

            else if (typeof value === 'string' && value.length > 17) {
              const lines = this.breakText(value);
              formattedItem[key] = lines.join('\n');

            }

            else {
              formattedItem[key] = value;

            }
          }
        }

        return formattedItem;
      });
    }
    return [];
  }
  breakText(input: string): string[] {
    const words = input.split(' ');
    const lines: string[] = [];

    words.forEach(word => {

      if (word.length > 17) {

        const firstPart = word.slice(0, 17);
        const secondPart = word.slice(17);


        lines.push(firstPart);

        lines.push(`- ${secondPart}`);
      } else {

        lines.push(word);
      }
    });

    return lines;
  }

  private isValidDateFormat(dateString: string): boolean {


    const isoDatePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|([+-]\d{2}:\d{2}))?$/;
    return isoDatePattern.test(dateString);
  }


  sortResultsByNumber(data: any): any {
    if (!data || data.length === 0) {
      return data;
    }

    return data.sort((a: any, b: any) => {
      for (const key in a) {
        if (a.hasOwnProperty(key) && b.hasOwnProperty(key)) {
          if (typeof a[key] === 'number' && typeof b[key] === 'number') {
            return b[key] - a[key];
          }
        }
      }

      return 0;
    });
  }
  processPercentageFields(data: any): any {
    if (data !== undefined) {
      return data.map((item: any) => {
        const formattedItem: { [key: string]: string | number | null } = {};

        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            const value = item[key];

            if (typeof value === 'string' && value.includes('%')) {
              // Remove '%' symbol and return the number
              formattedItem[key]= value.replace('%', '');
            }      
            else {
              formattedItem[key] = value;

            } 
          
          }
        }

        return formattedItem;
      });
    }
    return [];
  }
}
